import React, { useState } from 'react';
import ReactInputMask from 'react-input-mask';
import userApi from '../../services/userApi';
import Notification from '../../components/notification/notification';
import AddressAutocomplete from '../../components/address-autocomplete/address-autocomplete';
import { TWInput, TWButton, FieldLabel } from '../../components/ui';

const ContactUs = () => {
  const [form, setForm] = useState({
    name: '',
    ownername: '',
    ownerphone: '',
    address: '',
  });
  const [notf, setNotf] = useState({
    display: false,
    type: 'error',
    message: '',
  });
  const [errors, setErrors] = useState({
    name: false,
    ownername: false,
    ownerphone: false,
    address: false,
  });
  const [loading, setLoading] = useState(false);

  const onFormChange = (val, key) =>
    setForm((prev) => ({ ...prev, [key]: val }));

  const onAddressSelect = (obj) => {
    if (typeof obj === 'object') {
      setForm((prev) => ({
        ...prev,
        address: obj.street,
        city: obj.city,
        state: obj.state,
        postalcode: obj.zipCode,
        longitude: obj?.longitude || '',
        latitude: obj?.latitude || '',
        apartment: obj?.apartment || '',
      }));
    } else {
      setForm((prev) => ({ ...prev, address: obj }));
    }
  };

  const onFormSubmit = async () => {
    if (!form.name || !form.ownername || !form.ownerphone || !form.address) {
      setErrors({
        name: !form.name,
        ownername: !form.ownername,
        ownerphone: !form.ownerphone,
        address: !form.address,
      });
      return;
    }
    setErrors({
      name: false,
      ownername: false,
      ownerphone: false,
      address: false,
    });

    try {
      setLoading(true);
      await userApi.contact({ ...form });
      setNotf({
        message: 'Contact Submitted Successfully',
        display: true,
        type: 'success',
      });
    } catch (error) {
      setNotf({
        message: 'An error occurred while submitting the form.',
        display: true,
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const phoneClass =
    'block w-full rounded-md border bg-white px-3 py-2 text-sm shadow-sm placeholder-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:bg-slate-900 dark:text-slate-100 dark:placeholder-slate-500 dark:focus:border-sky-400 dark:focus:ring-sky-400';

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-4 dark:bg-slate-900">
      <div className="w-full max-w-md space-y-6 rounded-md border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800">
        <span className="text-xs font-bold uppercase tracking-[0.15em] text-blue-600 dark:text-sky-400">
          Get in touch
        </span>
        <div>
          <h1 className="text-4xl font-semibold text-slate-900 dark:text-slate-100">
            Contact Us!
          </h1>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            Help us get in touch with you by providing your contact details
            below. We'll reach out to you as soon as possible.
          </p>
        </div>

        <TWInput
          label="Name"
          required
          value={form.name}
          onChange={(e) => onFormChange(e.target.value, 'name')}
          placeholder="Smith"
          error={errors.name ? 'Name cannot be empty' : undefined}
        />

        <TWInput
          label="Owner Name"
          required
          value={form.ownername}
          onChange={(e) => onFormChange(e.target.value, 'ownername')}
          placeholder="John Doe"
          error={errors.ownername ? 'Owner name cannot be empty' : undefined}
        />

        <div>
          <FieldLabel htmlFor="ownerphone" required>
            Owner Phone
          </FieldLabel>
          <ReactInputMask
            mask="(999) 999 9999"
            maskPlaceholder=" "
            value={form.ownerphone}
            onChange={(e) => onFormChange(e.target.value, 'ownerphone')}
            type="text"
            id="ownerphone"
            placeholder="(123) 456 7890"
            className={`${phoneClass} ${
              errors.ownerphone
                ? 'border-rose-400 dark:border-rose-500/70'
                : 'border-slate-200 dark:border-slate-600'
            }`}
          />
          {errors.ownerphone && (
            <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">
              Owner phone cannot be empty
            </p>
          )}
        </div>

        <div>
          <FieldLabel htmlFor="address" required>
            Address
          </FieldLabel>
          <AddressAutocomplete
            value={form.address}
            onChange={(e) => onAddressSelect(e)}
          />
          {errors.address && (
            <p className="mt-1 text-xs text-rose-600 dark:text-rose-400">
              Address cannot be empty
            </p>
          )}
        </div>

        <TWButton
          variant="primary"
          size="lg"
          label="Submit"
          loading={loading}
          onClick={onFormSubmit}
        />
      </div>

      <Notification
        display={notf.display}
        type={notf.type}
        message={notf.message}
        onClose={() => setNotf((prev) => ({ ...prev, display: false }))}
      />
    </div>
  );
};

export default ContactUs;
